export default function ArtworkIcon({ className="", onClick=null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 500 500"
    >
      <path d="M405.25,141H94.75c-1.09,0-1.97.88-1.97,1.96v210.47c0,1.09.88,1.97,1.97,1.97h48.47l-36.73,66.73
                 c-3.2,5.83-1.08,13.17,4.75,16.37c1.77,0.98,3.78,1.5,5.8,1.5c4.41,0,8.45-2.39,10.57-6.25l43.13-78.35h67.21v36.83
                 c0,6.65,5.4,12.06,12.06,12.06s12.05-5.41,12.05-12.06v-36.83h67.11l43.13,78.35c2.13,3.86,6.18,6.25,10.57,6.25
                 c2.02,0,4.02-0.52,5.81-1.5c5.82-3.2,7.95-10.54,4.75-16.37l-36.73-66.73h48.56c1.09,0,1.97-0.88,1.97-1.97V142.96
                 c0-1.08-0.88-1.96-1.97-1.96ZM381.81,329.99H118.19v-163.58h263.62v163.58Z"/>
      <path d="M306.26,108.74c0,6.54-5.33,11.86-11.87,11.86h-88.78c-6.54,0-11.87-5.32-11.87-11.86s5.33-11.87,11.87-11.87h32.52v-25
                 c0-6.54,5.32-11.87,11.87-11.87s11.86,5.33,11.86,11.87v25h32.52c6.54,0,11.87,5.32,11.87,11.87Z"/>
    </svg>
  );
}
